var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppsmithAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 63,
    viewBox: "0 0 57 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint0_linear_975_21228)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint1_linear_975_21228)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint2_linear_975_21228)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint3_radial_975_21228)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint4_radial_975_21228)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint5_radial_975_21228)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint6_radial_975_21228)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint7_radial_975_21228)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint8_radial_975_21228)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9156 15.7785C39.6487 16.6036 39.0355 17.2713 38.2362 17.6074L31.9577 20.2474C30.9848 20.6564 30.9848 22.0349 31.9577 22.444L38.2648 25.096C39.0659 25.4328 39.6799 26.1027 39.9459 26.9301L42.7322 35.5964C43.0866 36.6988 44.6463 36.6988 45.0007 35.5964L47.7782 26.9574C48.0435 26.1323 48.655 25.4637 49.4532 25.1259L55.794 22.443C56.7636 22.0327 56.7636 20.6587 55.794 20.2484L49.4817 17.5775C48.6853 17.2405 48.0746 16.574 47.8084 15.7512L45.0001 7.0708C44.6443 5.97119 43.0886 5.97119 42.7328 7.0708L39.9156 15.7785Z",
    fill: "url(#paint9_radial_975_21228)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint10_linear_975_21228)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint11_linear_975_21228)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint12_linear_975_21228)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint13_radial_975_21228)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint14_radial_975_21228)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint15_radial_975_21228)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint16_radial_975_21228)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint17_radial_975_21228)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint18_radial_975_21228)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8135 4.47306C22.6882 4.86021 22.4005 5.17355 22.0254 5.33127L19.0792 6.57005C18.6227 6.762 18.6227 7.40886 19.0792 7.60081L22.0388 8.84524C22.4147 9.00331 22.7028 9.31766 22.8277 9.70589L24.1351 13.7725C24.3014 14.2898 25.0333 14.2898 25.1996 13.7725L26.5029 9.71873C26.6274 9.33155 26.9143 9.01779 27.2889 8.85931L30.2643 7.60032C30.7193 7.40782 30.7193 6.76305 30.2643 6.57054L27.3023 5.31723C26.9286 5.1591 26.642 4.84635 26.5171 4.46025L25.1993 0.386988C25.0324 -0.128996 24.3024 -0.128996 24.1354 0.386988L22.8135 4.47306Z",
    fill: "url(#paint19_radial_975_21228)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4252 62.1157C25.0003 61.3646 24.6759 59.8891 24.4521 57.689C22.0442 61.202 18.2001 62.9592 12.9198 62.9606C8.98498 62.9606 5.84764 61.9996 3.50773 60.0776C1.16783 58.1555 -0.00141512 55.4846 1.2853e-06 52.0648C1.2853e-06 45.4559 4.58491 41.6835 13.7547 40.7476L19.1725 40.2553C20.9784 40.0216 22.2751 39.5881 23.0626 38.9546C23.8502 38.3211 24.2439 37.3701 24.2439 36.1016C24.2439 34.5565 23.7482 33.42 22.7567 32.6918C21.7652 31.9637 20.0861 31.6004 17.7192 31.6018C15.1697 31.6018 13.3411 32.0318 12.2335 32.8918C11.1259 33.7518 10.4772 35.2395 10.2874 37.355H1.66782C2.1749 29.1079 7.54661 24.9844 17.783 24.9844C27.7417 24.9844 32.7204 28.6163 32.719 35.8802V55.2359C32.719 58.4235 33.2055 60.7168 34.1786 62.1157H25.4252ZM21.6732 54.3502C23.387 52.8252 24.2439 50.6337 24.2439 47.7757V44.4734C23.4111 45.2216 22.045 45.7132 20.1456 45.9483L15.4225 46.5115C13.1067 46.7982 11.4509 47.3486 10.4552 48.1627C9.45947 48.9768 8.96373 50.16 8.96798 51.7122C8.96798 53.2601 9.48851 54.467 10.5296 55.3327C11.5706 56.1984 13.0642 56.6284 15.0104 56.6226C17.7412 56.6298 19.9621 55.8723 21.6732 54.3502Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_975_21228",
    x1: 46.1749,
    y1: 6.24609,
    x2: 39.6964,
    y2: 29.5928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2802A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_975_21228",
    x1: 41.7069,
    y1: 28.2524,
    x2: 39.8727,
    y2: 38.3512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458251,
    stopColor: "#E88518",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_975_21228",
    x1: 37.6858,
    y1: 25.944,
    x2: 27.5954,
    y2: 25.6747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.361577,
    stopColor: "#E88518",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65429"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.9621 -2.05525) rotate(103.828) scale(17.1016 47.2503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9765 30.3834) rotate(-72.5097) scale(3.59399 0.350663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7334 19.2674) rotate(-157.145) scale(4.09854 0.39989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.24 12.9312) rotate(-106.504) scale(5.27379 0.369518)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.7312 22.9894) rotate(17.855) scale(10.5002 1.50802)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.392629,
    stopColor: "#F9370C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9910C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.9816 36.8754) rotate(-104.425) scale(12.6394 1.81526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.392629,
    stopColor: "#F9370C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9910C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.8069 27.5001) rotate(-46.023) scale(2.80228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.584555,
    stopColor: "#F9370C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9910C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_975_21228",
    x1: 25.7506,
    y1: 7.6735e-8,
    x2: 22.7105,
    y2: 10.9554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2802A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65429"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_975_21228",
    x1: 23.654,
    y1: 10.3264,
    x2: 22.7933,
    y2: 15.0652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.458251,
    stopColor: "#E88518",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E83D18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_975_21228",
    x1: 21.7671,
    y1: 9.24316,
    x2: 17.0322,
    y2: 9.11681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.361577,
    stopColor: "#E88518",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E65429"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5892 -3.89538) rotate(103.828) scale(8.02486 22.1721)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6575 11.3263) rotate(-72.5097) scale(1.68647 0.164547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3589 6.11023) rotate(-157.145) scale(1.92322 0.187647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.7811 3.13697) rotate(-106.504) scale(2.47471 0.173395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5037 7.85673) rotate(17.855) scale(4.92716 0.707631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.392629,
    stopColor: "#F9370C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9910C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7829 14.3727) rotate(-104.425) scale(5.93101 0.851803)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.392629,
    stopColor: "#F9370C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9910C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_975_21228",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8239 9.97339) rotate(-46.023) scale(1.31496)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.584555,
    stopColor: "#F9370C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9910C",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppsmithAi);
export default __webpack_public_path__ + "static/media/appsmith-ai.c003471f7e40e78d7786b1e61d84d2ce.svg";
export { ForwardRef as ReactComponent };